export enum WebTypeId {
  TEMPLATE = 0,
  SITES = 1,
  WORDPRESS = 2,
}
